import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** Merge Tailwind classes safely: `clsx` + `twMerge` (later class wins on conflicting utilities). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
